import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../store/storeFunctions';

class SearchQuerySummary extends React.Component {
    state = {
        maxLen: 25,
        legalFormsExpanded: false,
        rdcExpanded: false,
        icoDicExpanded: false,
        companyNameExpanded: false,
        rpNameExpanded: false
    };

    render() {
        const fd = this.props.searchParams;
        if (isNullOrUndefined(fd))
            return '';

        return (
            <div className="sr-labels bs-sr-labels" style={{marginRight:'1em'}}>
                {this.renderLabel(fd.name, "Search.Label.Name")}
                {this.renderLabel(fd.dob, "Search.Label.Dob")}
                {this.renderLabel(fd.street, "Search.Label.Street")}
                {this.renderLabel(fd.bankAccount, "Search.Label.BankAccount")}
                {fd.rdcIds !== undefined && fd.rdcIds.length > 0 && !isNullOrUndefined(this.props.searchDomains) && this.renderLabelFromRequestData(fd.rdcIds, this.props.searchDomains.rdcIds, "Search.Label.RegionDistrictCity", "rdcExpanded")}
                {this.renderLabel(fd.zip, "Search.Label.Zip")}
            </div>
        );
    };

    renderLabel = (content, translationKey) => {
        if (content === null || content === undefined) {
            return '';
        }
        return (
            <React.Fragment>
                <span className="sr-label"><Translate id={translationKey} />: </span>
                <span className="sr-label-value">{content}</span>
            </React.Fragment>
        )
    };

    renderLongLabel = (content, translationKey, stateKey) => {
        if (content === null || content === undefined) {
            return '';
        }

        if (content.length <= this.state.maxLen)
            return this.renderLabel(content, translationKey)

        return this.renderExpandableLabel(`${content.substring(0, this.state.MaxLen)}...`, content, translationKey, stateKey);
    };

    renderExpandableLabel = (contentNotExpanded, contentExpanded, translationKey, stateKey) => {
        return (
            <span className="sr-label-expandable" onClick={() => this.setState({ [stateKey]: !this.state[stateKey] })}>
                <span className="sr-label"><Translate id={translationKey} />: </span>
                <span className="sr-label-value">{ReactHtmlParser(this.state[stateKey] ? contentExpanded : contentNotExpanded)}</span>
            </span>
        )
    }

    renderLabelFromRequestData = (items, labels, translationKey, stateKey) => {
        if (items.length <= 0)
            return null;

        if (items.length === 1)
            return this.renderLabel(labels[items[0]], translationKey);

        return this.renderExpandableLabel(`${labels[items[0]].substring(0, this.state.MaxLen)} ... (${items.length})`,
            items.map(x => labels[x]).join("; "), translationKey, stateKey);
    }
}

export default connect(state => state.search)(SearchQuerySummary);